'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var StoresQuadRuStore = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "#2B71F6",
                fillRule: "evenodd",
                d: "M34.119 4H21.87C16.118 4 14 6.11 14 11.876v12.248C14 29.89 16.11 32 21.876 32h12.248c5.766 0 7.88-2.11 7.88-7.876V11.876C41.993 6.11 39.884 4 34.118 4",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M29.96 21.31a1.73 1.73 0 0 1-1.331-1.673v-9.315c0-.898.861-1.557 1.75-1.338l5.627 1.384c.782.193 1.33.882 1.33 1.673v9.316c0 .898-.86 1.556-1.75 1.338zM19.383 25.597a1.73 1.73 0 0 1-1.33-1.673V14.61c0-.899.86-1.557 1.75-1.338l5.627 1.384c.782.193 1.33.882 1.33 1.673v9.315c0 .898-.861 1.557-1.75 1.338z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M24.657 23.453a1.73 1.73 0 0 1-1.33-1.672v-9.316c0-.898.86-1.556 1.75-1.338l5.626 1.385c.783.192 1.331.882 1.331 1.673V23.5c0 .898-.861 1.557-1.75 1.338z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#2B71F6",
                d: "M28.355 24.364a.57.57 0 0 1-.43-.533l-.245-7.108c-.07-.942-.781-1.691-1.523-1.911a.1.1 0 0 0-.109.04.084.084 0 0 0 .02.112c.183.14.686.596.686 1.381l-.001 7.62zM33.657 22.218a.566.566 0 0 1-.43-.53l-.245-7.108c-.07-.943-.781-1.692-1.523-1.912a.1.1 0 0 0-.109.04.083.083 0 0 0 .02.113c.183.14.686.595.686 1.38l-.001 7.622z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M11.683 44.32c1.15-.261 1.907-1.042 1.907-2.064 0-1.263-1.14-2.15-2.74-2.15H8v6.797h1.315v-2.497h.932l2.039 2.497h1.545zm-.833-3.153c.822 0 1.392.443 1.392 1.09 0 .645-.57 1.089-1.392 1.089H9.315v-2.18zM16.793 46.997c.69 0 1.326-.319 1.688-.849l.252.752h.942v-5.012h-1.26v2.901c0 .713-.537 1.215-1.272 1.215-.723 0-1.227-.502-1.227-1.215v-2.901h-1.26v3.026c0 1.205.92 2.083 2.137 2.083M23.697 46.989c1.457 0 2.663-.733 2.663-1.947 0-1.36-1.26-1.755-2.345-2.083-.845-.25-1.579-.482-1.579-1.089 0-.53.559-.81 1.217-.81.69 0 1.184.319 1.458.858l1.25-.183C25.965 40.675 24.967 40 23.608 40c-1.403 0-2.521.713-2.521 1.928 0 1.369 1.26 1.745 2.345 2.063.834.241 1.579.472 1.579 1.09 0 .54-.56.848-1.304.848-.855 0-1.316-.357-1.721-1.003l-1.272.193c.373 1.147 1.557 1.87 2.982 1.87M29.782 45.934c-.428 0-.636-.184-.636-.56V42.85h1.699v-.964h-1.7v-1.446h-.942l-.317 1.446h-.932v.964h.931v2.525c0 .984.647 1.523 1.897 1.523h1.063l.11-.963zM34.557 47c1.786 0 3.047-1.08 3.047-2.603s-1.26-2.603-3.047-2.603-3.047 1.08-3.047 2.603S32.77 47 34.557 47m0-1.012c-1.03 0-1.732-.646-1.732-1.59 0-.946.701-1.591 1.732-1.591 1.03 0 1.732.645 1.732 1.59s-.702 1.59-1.732 1.59M39.962 46.9v-2.96c0-.636.35-.992 1.118-.992h.724l-.11-1.06h-.241c-.669 0-1.184.163-1.568.722l-.241-.722h-.943V46.9zM48 44.34c0-1.447-1.228-2.546-2.96-2.546s-2.959 1.09-2.959 2.603S43.31 47 45.041 47c1.183 0 2.302-.492 2.729-1.446l-1.184-.174c-.274.357-.8.608-1.469.608-.964 0-1.6-.52-1.72-1.292h4.581c.011-.106.022-.222.022-.357m-2.96-1.582c.79 0 1.382.444 1.59 1.07h-3.157c.209-.645.8-1.07 1.568-1.07"
            })
        ]
    }));
});

export { StoresQuadRuStore, StoresQuadRuStore as default };
